import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "./BannerStyle.scss";
import { Col, Container, Row } from "react-bootstrap";
const partnerImage = require("../../../Assets/Images/canva/partnerWithUs.png");
const PartnerWithUs = () => {
  let { t } = useTranslation();
  const scrollToSection = (sectionId) => {
    const targetElement = document.querySelector(sectionId);
    if (targetElement) {
      targetElement.scrollIntoView({ behavior: "smooth" });
    }
  };
  return (
    <section id="canvaSalesTeam" className="BannerImgNine">
      <Container  fluid className="h-100" >
        <Row className="justify-content-between align-items-center  h-100">
          <Col md={6} sm={12}>
            <div className="text-center h-100 my-3">
              <img className="img-fluid w-75" src={partnerImage} alt="" />
            </div>
          </Col>
          <Col md={6} sm={12}>
            <div className="mt-1 h-100">
            
                <h3 className="d-block heading">
                  {/* {t("AboutUs")} */}
                  Partner With Us
                </h3>
                <p className="py-2 canvaText pe-3">
                  {/* {t("AboutUsTextFirst")} */}
                  Our team will be happy to chat about your business's cashless
                  tipping needs. Track performance, automate payouts, and
                  increase employee satisfaction with increased tips.
                </p>
                <p className="py-2 canvaText pe-3">
                  {/* {t("AboutUsText2nd")} */}
                  Click on the link below to schedule your demo today.
                </p>
                <p className="py-2 canvaText pe-3">
                  {/* {t("AboutUsText2nd")} */}
                  We look forward to partnering with you!
                </p>
              </div>
              <Col md={6} className="my-4 text-center">
                <button
                  type="button"
                  class="landingBtn btn w-100 py-3 btn-outline-warning border border-dark"
                >
                  <Link
                    onClick={() => scrollToSection("#canvaContact")}
                    className="nomrateFont py-3 fw-bold text-dark  w-100"
                  >
                    Request A Demo
                  </Link>
                </button>
              </Col>
           
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default PartnerWithUs;
